import { mergeIntervals, TimeInterval } from "lib/IntervalUtils";

export enum NativeMediaErrorCode {
    NONE = 0,
    ABORT = 1,
    NETWORK = 2,
    DECODE = 3,
    NO_SUPPORT = 4,
}

export enum NativeMediaEventType {
    LOADED_DATA = 'loadeddata',
    PLAY = 'play',
    PAUSE = 'pause',
    TIME_UPDATE = 'timeupdate',
    ERROR = 'error',
    END = 'ended',
    SEEK = 'seeking',
    PROGRESS = 'progress',
}

export enum ObserverMediaEventType {
    LOADED_DATA = 1,
    PLAY = 2,
    PAUSE = 3,
    TIME_UPDATE = 4,
    ERROR = 5,
    END = 6,
    SEEK = 7,
    SRC = 8,
    PROGRESS = 9,
    LOADTIME = 10
}

// A map between native and observer media events to translate native types.
// NOTE: Not generated dynamically to limit mistakes when adding new mappings.
const eventTypeMap: any = {};
eventTypeMap[NativeMediaEventType.LOADED_DATA] = ObserverMediaEventType.LOADED_DATA;
eventTypeMap[NativeMediaEventType.PLAY] = ObserverMediaEventType.PLAY;
eventTypeMap[NativeMediaEventType.PAUSE] = ObserverMediaEventType.PAUSE;
eventTypeMap[NativeMediaEventType.TIME_UPDATE] = ObserverMediaEventType.TIME_UPDATE;
eventTypeMap[NativeMediaEventType.ERROR] = ObserverMediaEventType.ERROR;
eventTypeMap[NativeMediaEventType.END] = ObserverMediaEventType.END;
eventTypeMap[NativeMediaEventType.SEEK] = ObserverMediaEventType.SEEK;

export function observeMedia(media: HTMLVideoElement, cb: (args: any) => void) {
    let bufferHistory: TimeInterval[] = [];
    let maxTotalTime = 0;

    const emit = (observerEventType: ObserverMediaEventType) => {
        cb({
            emittedAt: (new Date()).getUTCDate(),
            type: observerEventType,
            currentTime: media.currentTime,
            videoWidth: media.videoWidth,
            videoHeight: media.videoHeight,
            paused: media.paused,
            errorCode: media.error ? media.error.code : NativeMediaErrorCode.NONE,
        });
    };

    const onNativeMediaEvent = (event: Event) => {
        // CAPTURA SOMENTE O EVENTO DE PROGRESS PARA CALCULAR O TOTAL TRAFEGO CARREGADO,
        if (event.type == NativeMediaEventType.PROGRESS) {

            // O navegador fez uma limpeza automática de memória (também chamada de Buffer Garbage Collection).
            // Então é necessário acumular o "Delta" de novos dados.

            const buffered: TimeRanges = media.buffered;

            // 1. Captura o estado atual do buffer do navegador e adiciona ao histórico
            for (let i = 0; i < buffered.length; i++) {
                const start: number = buffered.start(i);
                const end: number = buffered.end(i);

                bufferHistory.push([start, end]);
            }

            // 2. Faz a fusão dos dados
            bufferHistory = mergeIntervals(bufferHistory);

            // 3. Calcula o total real de segundos carregados
            const totalTime = bufferHistory.reduce((acumulador, [start, end]) => {
                return acumulador + (end - start);
            }, 0);

            // 4. Exibe os resultados formatados
            // console.clear();
            // console.log("Intervalos consolidados (sem duplicatas):", historicoBuffer);
            //console.log(`Total real carregado: ${totalTime.toFixed(2)} segundos.`);

            // 5. Registra novo acumulado para envio ao servidor.
            if (maxTotalTime < totalTime) {
                maxTotalTime = totalTime;

                const utc = new Date();
                utc.setHours(utc.getHours() - (utc.getTimezoneOffset() / 60));

                cb({
                    emittedAt: utc.getTime(),
                    type: ObserverMediaEventType.LOADTIME,
                    currentTime: totalTime,
                    videoWidth: media.videoWidth,
                    videoHeight: media.videoHeight,
                    paused: false,
                    errorCode: media.error ? media.error.code : NativeMediaErrorCode.NONE,
                });
            }
        }

        // == NÃO VAMOS ENVIAR OS DEMAIS EVENTOS ==
        // const observerEventType = eventTypeMap[event.type] || undefined;

        // if (!observerEventType) {
        //     return;
        // }

        // emit(observerEventType);
    };

    /* == NÂO VAMOS MAIS OBSERVAR TUDO ==

    const nativeEventTypes = Object.values(NativeMediaEventType);

    // Add event listeners on all entries listed in NativeMediaEventType.
    nativeEventTypes.forEach((nativeEventType) => {
         media.addEventListener(nativeEventType, onNativeMediaEvent);
    });

    */

    // == SOMENTE EVENTO DE PROGRESS ==
    media.addEventListener(NativeMediaEventType.PROGRESS, onNativeMediaEvent);

    // Monitor VideoElement properties mutation.
    const mutationObserver = new MutationObserver((mutationList, observer) => {
        mutationList.forEach((record) => {
            // For user-agent not supporting the attributeFilter option.
            if (record.attributeName === 'src') {
                emit(ObserverMediaEventType.SRC);
            }
        });
    });

    /* == NÃO NECESSÁRIO ==

    mutationObserver.observe(media, {
         attributes: true,
         attributeFilter: ['src']
     });

    */

    return () => {
        /* == NÂO NECESSÁRIO ==

        // Remove event listeners on all entries listed in NativeMediaEventType.
        nativeEventTypes.forEach((nativeEventType) => {
            media.removeEventListener(nativeEventType, onNativeMediaEvent);
        });

        */

        // SOMENTE O EVENTO DE PROGRESS
        media.removeEventListener(NativeMediaEventType.PROGRESS, onNativeMediaEvent);

        mutationObserver.disconnect();
    };
}
